export function getDateDaysAgo(days: number) {
  const d = new Date();
  d.setDate(d.getDate() - days);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
}

export function formatDuration(
  seconds: number | null | undefined,
): string | null {
  if (!seconds || seconds <= 0) return null;
  if (seconds < 60) return `${Math.round(seconds)}s`;
  const minutes = seconds / 60;
  if (minutes < 60) return `${Math.round(minutes)}m`;
  const hours = minutes / 60;
  if (hours < 24) return `${Math.round(hours)}h`;
  const days = hours / 24;
  if (days < 30) return `${Math.round(days)}D`;
  const months = days / 30;
  if (months < 12) return `${Math.round(months)}M`;
  return `${Math.round(months / 12)}Y`;
}
